module.exports = __webpack_public_path__ + "img/库尔_圣迭戈.230cbd4b.webp";